import * as React from "react"

function SvgX(props) {
    return (
        <svg width={24} height={24} fill="none" {...props}>
            <path
                d="M16.192 6.344l-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242-1.414-1.414z"
                fill="#0D1930"
            />
        </svg>
    )
}

export default SvgX
